const NoData = ({ message = "No records available." }) => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        color: "#6c757d",
        fontSize: "16px",
      }}
    >
      <p>{message}</p>
    </div>
  );
};

export default NoData;
